var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-row tw-gap-4"},[_c('div',{staticClass:"tw-w-full"},[_c('div',{staticClass:"admin-generated",domProps:{"innerHTML":_vm._s(_vm.contents.market_place.body)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }